export default {
  title: 'World Coin — WLD',
  tokenName: 'World Coin — WLD',
  description: 'WLD 是 World 生態系統的原生數位代幣，也是 World Chain 上最重要的鏈上資產之一。WLD 原始代幣部署於 Ethereum，並透過橋接形式在 World Chain 上流通，讓使用者能夠在 World 生態中持有、轉移及使用 WLD。\n\n在 Bubble Wallet 中，WLD 扮演連接 GGMOMOMO 遊戲資產與 World Chain 生態的重要角色。玩家可以透過 WLD 與支援的遊戲代幣進行鏈上資產交換，讓遊戲世界中的資產進一步連接至更廣泛的 Web3 生態。\n\nWLD 連接 World，亦讓 Bubble Wallet 與更大的鏈上世界連接起來。',
  topUpWld: '增值WLD',
  openInfo: '開啟 WLD 說明',
  close: '關閉 WLD 說明',
} as const;
